<template>
  <div class="pdp-wrap" v-if="detailInfo">
    <Breadcrumb :config="{items: navItems}" />
    <div class="m-product-details__main">
      <div class="layout clearfix">
        <!-- 页面主体 -->
        <div class="ms-row row-collapsed">
          <!-- 左侧轮播图 -->
          <div class="col-xs-12 col-md-8 float-left detail-left">
            <div class="primary-images m-product-details__primary-images">
              <div class="carousel slide" v-if="kvImages && kvImages.length">
                <PDPSwiper :items="kvImages" />
              </div>
              <!-- <div class="carousel slide" v-if="detailInfo.banner && detailInfo.banner.length">
                <PDPSwiper :items="detailInfo.banner" />
              </div> -->
            </div>
          </div>
          <!-- 右侧基本信息 -->
          <div class="col-xs-12 col-md-4 m-product-details__main-info float-left">
            <div :class="['info-box', infoPos ]">
              <h1 class="product-name m-product-details__product-name zh">{{detailInfo.name}}</h1>
              <h2 class="product-name_en m-product-details__product-name en" v-if="detailInfo.subtitle">{{detailInfo.subtitle}}</h2>
              <h2 v-if="isMobile" class="m-product-details__description-short pdp__desc">{{ detailInfo.h5_desc || '' }}</h2>
              <h2 v-else class="m-product-details__description-short pdp__desc">{{ detailInfo.pc_desc || '' }}</h2>
              <!-- 数量 & 价格 -->
              <div class="quantity-price">
                <div class="m-product-details__description-short">
                  数量： <span class="num">1</span>
                </div>
                <div class="m-product-details__description-short">
                  <div class="prices m-product-details__prices c-product-tile__price-container">
                    <div class="price c-product-tile__price">
                      <div>
                        <div class="sales c-product-tile__price-sales c-button--bold">
                          <p class="text--no-margin">
                            <span class="value">￥{{ detailInfo.money | toFixed(2) }}</span>
                          </p>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <!-- 产品详情区域 -->
              <template v-if="detailInfo.goodsList && detailInfo.goodsList.length">
                <div class="attribute m-product-details__variation-attribute">
                  <div class="m-product-set__items">
                    <div class="m-product-set__item ms-row" v-for="(item, index) in detailInfo.goodsList" :key="index">
                      <div class="col-xs-3" v-if="item.kv_images && item.kv_images.length">
                        <img :src="item.kv_images[0].url" :alt="item.product_name" />
                      </div>
                      <div :class="['col-xs-9', item.display_type == 'color' ? 'color-vessel' : '']">
                        <div class="m-product-set__item-name">{{item.product_name}}</div>
                        <div class="ms-row">
                          <div :class="[item.display_type == 'color' ? 'col-xs-7' : 'col-xs-9']">
                            <div class="m-product-details__selected-color" v-if="item.display_type == 'color'">
                              色号： 
                              <span v-if="item.display_type == 'color'" class="color-value" :style="{background: `#${item.spec_property}`}"></span>
                              {{item.spec_desc}}
                            </div>
                            <div class="m-product-details__selected-color" v-else>
                              {{item.display_type | classify }}：{{item.spec_desc}}
                            </div>
                            <div class="m-product-details__selected-color">
                              数量：{{item.num}}
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </template>
              <!-- 立即购买 -->
              <div class="m-product-details__add-to-cart" v-if="detailInfo">
                <div class="c-product-tile__actions-wrapper">
                  <button class="add-to-cart js-add-to-cart-button c-button c-button--primary" @click="toCheckout" v-if="detailInfo.sold_out != 1">立即购买</button>
                  <button class="add-to-cart js-add-to-cart-button c-button c-button--primary" disabled v-else>已售罄</button>
                </div>
              </div>
            </div>
          </div>
          <!-- 页面详细信息 -->
          <div class="col-xs-12 col-md-8 detail-left detail-left_media" v-if="Array.isArray(detailInfo.content) && detailInfo.content.length">
            <div class="image-wrapper">
              <template v-for="(item, index) in detailInfo.content">
                <template v-if="item.tag == 'image' && item.data && item.data.src">
                  <img class="pdp-detail-image__item" :src="item.data.src" :alt="detailInfo.product_name" :key="`Item-Img-${index}`" @load="onImageLoaded" @click="actionHandler(item.action)" />
                </template>
                <template v-else-if="item.tag == 'image' && item.src && (item.src.pc || item.src.h5)">
                  <img class="pdp-detail-image__item show-for-md" :src="item.src.pc" :alt="detailInfo.product_name" :key="`Item-Img-PC-${index}`" @load="onImageLoaded" @click="actionHandler(item.action)" />
                  <img class="pdp-detail-image__item hide-for-md" :src="item.src.h5" :alt="detailInfo.product_name" :key="`Item-Img-H5-${index}`" @load="onImageLoaded" @click="actionHandler(item.action)" />
                </template>
                <template v-else-if="item.tag == 'video' && item.video">
                  <VideoWrap :vSrc="item.video" :iSrc="item.src" :showControls="true" :key="`Item-V-${index}`" />
                </template>
                <template v-else-if="item.tag == 'multi_image' && Array.isArray(item.nodes) && item.nodes.length">
                  <template v-for="(multiItem, multiIndex) in item.nodes">
                    <img class="pdp-detail-image__item" :src="multiItem.src" :alt="detailInfo.product_name" :key="`Item-MultiImage-${index}-${multiIndex}`" @load="onImageLoaded" @click="actionHandler(multiItem.action)" />
                  </template>
                </template>
                <template v-else-if="item.tag == 'product_recommend' && Array.isArray(item.nodes) && item.nodes.length">
                  <div class="pdp-recommends" :key="`Item-Recommend-${index}`" >
                    <div class="pdp-recommend__item" v-for="(recItem, recIndex) in item.nodes" :key="`Item-RecItem-${index}-${recIndex}`">
                      <img class="pdp-recommend__item-image" :src="recItem.src" @click="actionHandler(recItem.action)" @load="onImageLoaded" />
                    </div>
                  </div>
                </template>
                <template v-else-if="item.tag == 'product_detail_multi_part_text'">
                  <ProductDetailMultiPartText :config="item" :key="`Item-Cmp-${index}`"/>
                </template>
                <template v-else-if="item.tag == 'product_detail_title_desc'">
                  <ProductDetailTitleDesc :config="item" :key="`Item-Cmp-${index}`"/>
                </template>
                <template v-else-if="item.tag == 'product_detail_text'">
                  <ProductDetailText :config="item" :key="`Item-Cmp-${index}`"/>
                </template>
                <template v-else>-</template>
              </template>
            </div>
          </div>
        </div>
      </div>
      <!-- 底部内容 -->
      <div class="layout">
        <div class="ms-row">
          <div class="col-xs-12 extra-recommend">
            <div class="module-header">
              <IconTitle :config="{title:'热销星品'}" />
            </div>
            <div class="module-body">
              <Recommend region="empty_order_rec" />
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import PDPSwiper from "@/components/PDPSwiper";
import 'vuescroll/dist/vuescroll.css';
import IconTitle from '@/components/IconTitle.vue';
import VideoWrap from '@/components/VideoWrap.vue';
import Recommend from '@/components/Recommend.vue';
import ProductDetailMultiPartText from '@/components/ProductDetailMultiPartText';
import ProductDetailTitleDesc from '@/components/ProductDetailTitleDesc';
import ProductDetailText from '@/components/ProductDetailText';
import types from "@/store/types";
import api from "@/utils/api";
import utils from "@/utils/index";
import actionMixins from "@/utils/action.mixins";

export default {
  name: 'ProductDetailPage',
  mixins: [actionMixins],
  components: {
    Breadcrumb: () => import("@/components/Breadcrumb"), 
    PDPSwiper, IconTitle, Recommend, VideoWrap,
    ProductDetailMultiPartText, ProductDetailTitleDesc, ProductDetailText
  },
  data() {
    return {
      infoPos: "",
      detailInfo: null
    };
  },
  created() {
    this.onPageScroll = utils.throttle(this.onPageScroll, 100);
    this.loadSource();
  },
  methods: {
    loadSource() {
      api[types.QUERY_POST_TRIAL]({ id: this.$route.query.id }).then(res => {
        if (res.code == 1 && res.data && res.data.data) {
          let info = res.data.data;
          if (!info) {
            this.$toast({ message: "付邮试用活动不存在或已结束", iconCls: "failure" });
            this.$router.replace({ path: "/" });
            return false;
          }
         // 无权限
         if(info.limit_tag==1){
            api[types.SITE_CONFIG]({}).then(res => {
               let data = res?.data?.TRY_PERMISSION?.value;
               if( typeof data == 'string'){
                 data = JSON.parse(data) 
               }
               this.$toast({ message: data.title, iconCls: "failure" });
               setTimeout(()=>{
                   this.$router.replace({ path: data.pc});
               },2000)
            }) 
           return;
         }

          if (info.banner && typeof info.banner == "string") info.banner = JSON.parse(info.banner);
          if (info.content && typeof info.content == "string") info.content = JSON.parse(info.content);
          // 
          this.$store.commit('toggleNavType', true);
          utils.setPageInfo(`${info.name} - Sisley Paris`);
          // 
          this.detailInfo = info;
          // PC时才有该效果
          if (this.winW >= 1024 && Array.isArray(info.content) && info.content.length) {
            this._imageCount = info.content.reduce((prevSize, currItem) => {
              let currSize = 0;
              if (currItem.tag == 'multi_image' || currItem.tag == 'product_recommend') {
                currSize = currItem.nodes.length
              } else if (currItem.tag == 'image') {
                currSize = 1;
              }
              return prevSize + currSize;
            }, 0);
            // 有商品详情，但不是图片
            if (this._imageCount == 0) this.$nextTick(() => {
              this.initScroll();
            });
          }
        } else {
          this.$toast({ message: res.message, iconCls: "failure" });
        }
      }).catch(err => { console.warn(err); });
    },
    // 滚动处理
    initScroll() {
      let infoBox = document.querySelector(".info-box");
      let target = document.querySelector(".extra-recommend");
      if (!infoBox || !target) return false;
      let infoBoxRect = infoBox.getBoundingClientRect();
      let winH = window.innerHeight;
      //  
      this.scrollInfo = { infoBox, infoBoxRect, target, winH };
      // 
      window.addEventListener('scroll', this.onPageScroll, false);
      this.$once("hook:beforeDestroy", () => {
        window.removeEventListener("scroll", this.onPageScroll, false);
      });
    },
    // eslint-disable-next-line no-unused-vars
    onPageScroll(isLast) {
      this.renderScroll();
      this.scrollTimer && clearTimeout(this.scrollTimer);
      this.scrollTimer = setTimeout(() => {
        this.renderScroll();
      }, 500);
    },
    // 
    renderScroll() {
      let { infoBox, infoBoxRect, target, winH } = this.scrollInfo;
      let st = window.scrollY || document.documentElement.scrollTop || document.body.scrollTop;
      let clsName = infoBox.className;
      let rect = target.getBoundingClientRect();
      if (rect.top < winH) {
        this.infoPos = "absolute";
        infoBox.style.setProperty("bottom", winH - infoBoxRect.height -70 + 'px');
        !/absolute/.test(clsName) && (infoBox.className = clsName.replace(/(^\s*)|(\s*$)/g, '').replace(/\s+/g, ' ').replace("fixed", "") + " absolute");
        // console.info('abs');
      } else if (st >= 133) {
        this.infoPos = "fixed";
        infoBox.style.removeProperty("bottom");
        !/fixed/.test(clsName) && (infoBox.className = clsName.replace(/(^\s*)|(\s*$)/g, '').replace(/\s+/g, ' ').replace("absolute", "") + " fixed");
        // console.info('fix');
      } else {
        this.infoPos = "";
        infoBox.className = clsName.replace(/absolute|fixed/, "");
        // console.info('remove fix & abs', st);
      }
    },
    // 
    onImageLoaded() {
      this._imageLoadedCount = (this._imageLoadedCount || 0) + 1;
      if (this._imageLoadedCount == this._imageCount) this.initScroll();
    },
    // 
    toCheckout() {
      this.$router.push({ path: `/trialconfirm?nid=${this.$route.query.id}` });
    }
  },
  computed: {
    isLogin() { return this.$store.state.isLogin; },
    navItems() { return [{ text: this.detailInfo ? this.detailInfo.name : '付邮试用' }]; },
    kvImages() {
      if (Array.isArray(this.detailInfo?.banner) && this.detailInfo.banner.length) {
        return this.detailInfo?.banner.map(o => ({ tag: o.tag, url: o.data.src }));
      }
      return null;
    },
    winW() { return window.innerWidth; },
    isMobile() {
      return utils.isMobile();
    },
  },
  watch: {
    $route() { this.loadSource(); }
  }
};
</script>

<style lang="scss" scoped>
::v-deep .swiper-navigation-btns { padding: 0; }
::v-deep .swiper-navigation-btns .slider-info { display: none; }
//左边
.detail-left { padding-right: 0; padding-left: 0; }
.detail-left_media { margin-top: 40px; }
.m-product-details__main { padding-top: 50px; }
.m-product-details__primary-images {
  position: relative; padding: 0 20px;
  .carousel {
    position: relative;
    & /deep/ .slick-slider { width: 100%; height: 0; padding-bottom: 132.20%; }
    .carousel-item {
      img { width: 100%; height: auto; }
    }
    & /deep/ .swiper-nav-btn__wrap.sides-mode .slick-arrow {
      &, & span, & span svg {
        width: 3.625rem; height: 3.625rem;
      }
    }
  }
  .left-icon { transform: rotate(-180deg); display: block; }
  .left-icon, .right-icon { font-size: 28px; }
}
.slick-slider { position: relative; display: block; }
//右边
.num { padding: 0 16px; }
.m-product-details__main-info {
  width: 100%; padding-left: 0; padding-right: 0; margin-top: 3rem;
  .attribute { margin: 0 1.0625rem 0.5rem; }
  .m-product-details__product-name {
    margin: 0 1.0625rem 0.5rem; max-height: 4.5rem; overflow: hidden;
    &.zh { font-size: 24px; }
    &.en { font-size: 16px; }
  }
  .m-product-details__description-short {
    margin: 0 1.0625rem 0.625rem; max-height: 2rem; overflow: hidden; font-size: 0.875rem; color: #282828;
    display: flex; justify-content: flex-start; align-items: flex-start;
    &.pdp__desc { max-height: none; }
  }
  .top-xs { align-items: flex-start; }
  .m-product-details__prices {
    &.c-product-tile__price-container { float: none; }
    .c-product-tile__price--strike-through { color: #575757; }
  }
  .c-product-tile__price-container { font-size: 0.75rem; white-space: nowrap; }
  .c-product-tile__price--strike-through { margin-right: 0.625rem; color: #575757; text-decoration: line-through; display: inline-block; }
  .c-product-tile__price-sales { color: #000; display: inline-block; }
  .m-product-details__prices { margin-right: 1.0625rem; }
  .m-product-details__add-to-cart {
    margin: 0 1.0625rem 0.3125rem;
    .c-product-tile__actions-wrapper { margin-top: 0; }
    .c-button { margin-bottom: 1rem; display: block; width: 100%; margin-right: 0; margin-left: 0; max-width: 100%; }
  }
  .c-product-tile__actions-wrapper { margin-top: 0.9375rem; position: relative; z-index: 2; }
  .m-product-details__variation-attribute { margin-bottom: 1.25rem; }
  .m-product-details__variation-item {
    display: inline-block; margin-right: 1.0625rem; font-size: 0.8125rem; color: #575757; text-decoration: none; 
    border-bottom: 0.125rem solid transparent; cursor: pointer;
    &.selected { border-color: #000; }
  }
}
.color-value { border-radius: 50%; height: 0.625rem; width: 0.625rem; margin-right: 0.625rem; display: inline-block; }
// 礼盒
.m-product-set__items { margin: 0.625rem 1.0625rem 0.3125rem; }
.m-product-set__item {
  margin-bottom: 2.1875rem;
  img { width: 83px; height: auto; }
  .m-product-details__prices { margin-right: 0; margin-bottom: 0.625rem; margin-left: 0; }
  .m-product-details__selected-color { margin-bottom: 0.625rem; }
}
.color-vessel { position: relative; }
.m-product-set__item-name { color: #000; font-size: 0.75rem; font-family: HelveticaNeueLTW05-45Light, arial, sans-serif; text-decoration: none; display: block; margin-bottom: 0.625rem; }
.quantity-price { display: flex; flex-direction: column-reverse; margin-bottom: 2.5rem; }
.extra-recommend {
  padding-top: 6rem;
  .module-header { margin-bottom: 2rem; }
  .module-body {
    & /deep/ .recommond-wrap .header { display: none; }
  }
}
.image-wrapper {
  position: relative;
  img { width: 100%; height: auto; }
  .pdp-recommends {
    display: flex;
    .pdp-recommend__item {
      flex: 1;
      .pdp-recommend__item-image { cursor: pointer; }
    }
  }
}
@media screen and (min-width: 48em) {
  .quantity-price { flex-direction: row; justify-content: space-between; }
  .detail-left { padding-right: 50px; }
  .m-product-details__main {
    padding: 0 3.875rem; margin-top: 1.25rem;
    .m-product-details__primary-images { position: relative; padding: 0; margin-left: 3.5rem; }
    .image-wrapper {
      position: relative;
      img { width: 100%; height: auto; }
      .pdp-recommends {
        display: flex;
        .pdp-recommend__item { flex: 1; display: flex; }
      }
    }
  }
  .m-product-details__main-info {
    padding-bottom: 1.875rem;
    .m-product-details__product-name, .attribute { margin: 0 0 0.5rem; }
    .m-product-details__description-short { margin: 0 0 0.625rem; }
    .m-product-details__variation-attribute { margin-bottom: 1.25rem; }
    .m-product-details__color-swatches { margin-bottom: 0; }
    .c-product-tile__price-container { float: left; margin-right: 0.625rem; }
    .m-product-details__prices { margin-right: 0; }
    .m-product-details__add-to-cart {
      margin: 0 0 1.25rem;
      .c-button { margin-bottom: 1rem; }
    }
    // Fixed 定位
  }
  .m-product-set__items { margin: 0.625rem 0 0.3125rem; }
  .m-product-set__item {
    .m-product-details__prices { margin-right: 0; }
  }
}
@media screen and (min-width: 64em) {
  .pdp-wrap /deep/ .breadcrumb { padding: 0 1.875rem; }
  .detail-left_media { margin-top: 100px; }
  .m-product-details__main-info {
    margin-top: 0;
    .m-product-details__product-name {
      &.zh { font-size: 16px; }
      &.en { font-size: 15px; }
    }
    .info-box {
      width: 400px; max-width: 400px; z-index: 9;
      &.dialog__show { z-index: 11; }
      &.fixed {
        position: fixed; top: 70px;
        .m-product-details__add-to-cart {
          margin: 0;
          .buy-with-loyalty { margin-bottom: 0; }
        }
      }
      &.absolute { position: absolute; }
    }
  }
  .detail-left { width: 66.66666667%; min-height: 1px; }
  ::v-deep .swiper-navigation-btns .slick-arrow {
    display: block; width: 60px; height: 60px; background-color: #fff;
    position: absolute; top: 50%; transform: translateY(-50%); z-index: 1;
    &:hover { background-color: #000; }
    &.carousel__btn--prev { left: 0; transform: translateX(-50%) translateY(-50%); }
    &.carousel__btn--next { right: 0; transform: translateX(50%) translateY(-50%); }
  }
  .m-product-details__main {
    padding: 0 1.875rem; margin-top: 0;
    .m-product-details__primary-images {
      margin: 0 auto; width: 590px;
      .carousel {
        .carousel-item {
          img { width: 100%; max-width: 590px; height: auto; margin: 0 auto; display: block; }
        }
      }
    }
  }
  .m-product-details__main-info {
    .c-product-tile__actions-wrapper { margin-top: 1.25rem; }
    .m-product-details__add-to-cart {
      .c-button { margin-bottom: 1rem; }
    }
  }
}
@media screen and (min-width: 75em) {
  .m-product-details__main { padding: 0; }
  .m-product-details__main-info { padding-bottom: 3.125rem; }
}
</style>